// ThemeOption.tsx

import React, { useEffect, useState } from "react";

interface ThemeOptionProps {
  theme: string;
}

const ThemeOption: React.FC<ThemeOptionProps> = ({ theme }) => {
  const [appTheme, setAppTheme] = useState(
    localStorage.getItem("theme")
      ? localStorage.getItem("theme")
      : "light"
  );
  useEffect(() => {
    localStorage.setItem("theme", appTheme ?? "light");
  }, [appTheme]);

  return (
    <li>
      <input
        type="radio"
        name="theme-dropdown"
        className="theme-controller btn btn-sm btn-block btn-ghost justify-start"
        aria-label={theme}
        value={theme.toLowerCase()}
        onChange={() => setAppTheme(theme.toLowerCase())}
      />
    </li>
  );
};

export default ThemeOption;
